module.exports = "pegasus/assets/themelp1/travel/101.png";